import styled from "@emotion/styled"
import { mobileFirstDevice } from "../utils/media-queries"

export const Description = styled.p`
  white-space: pre-wrap;
  font-weight: 600;
  line-height: 140%;
  font-size: 18px;
  margin: 0 0;

  @media ${mobileFirstDevice.tablet} {
    font-size: 16px;
    line-height: 145%;
  }

  @media ${mobileFirstDevice.laptop} {
    line-height: 145%;
    font-size: 24px;
  }
`

export const Slogan = styled.span`
  color: ${({ theme }) => theme.colors.highlightText};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.03em;
  line-height: 115%;
  text-transform: uppercase;
  margin: 0 0;

  @media ${mobileFirstDevice.tablet} {
    font-size: 15px;
    letter-spacing: 0.4px;
    line-height: 145%;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 18px;
  }
`

export const SectionTitle = styled.h2`
  white-space: pre-wrap;
  font-weight: 600;
  font-size: 44px;
  line-height: 115%;
  letter-spacing: -0.015em;
  color: ${({ theme }) => theme.titleText};
  margin: 0 0;

  @media ${mobileFirstDevice.tablet} {
    font-size: 34px;
    line-height: 125%;
    letter-spacing: -0.25px;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 64px;
  }
`

export const Paragraph = styled.p`
  white-space: pre-wrap;
  font-weight: 500;
  font-size: 18px;
  line-height: 145%;
  color: ${({ theme }) => theme.tokenText};
  margin: 0 0;

  @media ${mobileFirstDevice.tablet} {
    font-size: 14px;
    letter-spacing: 0.25px;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 20px;
  }
`

export const ParagraphSmall = styled.p`
  white-space: pre-wrap;
  font-weight: normal;
  font-size: 16px;
  line-height: 145%;
  color: #565f76;

  @media ${mobileFirstDevice.tablet} {
    font-size: 14px;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 20px;
  }
`

export const Subtitle = styled.h5`
  white-space: pre-wrap;
  font-weight: 600;
  letter-spacing: 0.2em;
  font-size: 22px;
  line-height: 125%;
  color: ${({ theme }) => theme.colors.titleText};

  @media ${mobileFirstDevice.tablet} {
    font-size: 16px;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 32px;
  }
`
export const StatsCount = styled.p`
  font-weight: bold;
  color: #1199fa;
`
